/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { vappContainer } from '@/application';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { ADD_ROLE_TO_USER } from '../../api/graphql/addRoleToUser.mutation';
import { Graphql } from '@common/graphql';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator';
import { StorageModule } from '@vlinder-web/storage-module-react';
import axios from 'axios';
import { signInUserConfig } from '../../config/signInUser.config';
import { getErrorMessage } from '@/utils/error.message';
import { SWITCH_ROLE } from '@/pages/SwitchRoles/api/graphql';

export interface SignUpUserProps {
  email: string;
  firstName: string;
  lastName: string;
  password?: string;
  phoneNumber?: string;
  jwtToken?: string;
  role?: string;
  headers: any;
  trn: any;
  optionSelected: any;
}

export interface ISignUpUserMethods extends IPluginMethodMap {
  signUpUser(args: any): Promise<any>;
}

export class AddRolePageService implements IAgentPlugin {
  readonly methods: ISignUpUserMethods;

  constructor() {
    this.methods = {
      signUpUser: this.signUpUser.bind(this),
    };
  }
  async getAccessToken(args: { jwtToken: string; role: string; org: string }) {
    try {
      const res = await axios.post(
        `${apiConfig?.rest?.url}${signInUserConfig?.accessTokenEP}`,
        {
          jwtToken: args?.jwtToken,
          role: args?.role,
          org: args?.org,
        }
      );
      if (res?.data) {
        console.log('getAccessToken =', res?.data);
        return res?.data;
      }
    } catch (err: any) {
      throw Error(
        err?.response?.data?.error?.display_message ??
          err?.response?.data?.error?.error_message ??
          err?.response?.data?.error_message
      );
    }
  }
  async signUpUser(args: any) {
    const data = { ...args };
    delete data?.optionSelected;
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    const storageService = StorageModule.getInstance();
    const localToken = storageService.get('userProfile', 'local');
    const sessionToken = storageService.get('userProfile', 'session');
    const token = localToken?.accessToken ?? sessionToken?.accessToken;
    let usedToken = token;
    console.log(`signUpUser service:`, args, localToken, sessionToken, token);
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    } else {
      const orgRolesfor = localToken?.orgRolesfor ?? sessionToken?.orgRolesfor;
      const token = localToken?.signInToken ?? sessionToken?.signInToken;
      const res = await axios.post(
        `${apiConfig?.rest?.url}${signInUserConfig?.accessTokenEP}`,
        {
          jwtToken: token,
          role: orgRolesfor[0]?.uuid,
          org: orgRolesfor[0]?.org,
        }
      );
      if (res?.data) {
        const storageSrv = StorageModule.getInstance();
        const content = { ...res?.data };
        const _localData = storageSrv.get('userProfile', 'local');
        const _sessionData = storageSrv.get('userProfile', 'session');
        const userData = _sessionData ?? _localData;
        console.log('content->', content);
        storageSrv.set(
          'userProfile',
          {
            ...userData,
            accessToken: content?.accessToken,
            currentRole: orgRolesfor[0]?.value,
            currentOrg: orgRolesfor[0]?.org,
          },
          'session'
        );
        usedToken = content?.accessToken;
        gql = gql.withHeaders({
          authentication: content?.accessToken,
        });
      }
    }
    const client = gql.getClient();
    try {
      if (client) {
        const res = await client.mutation(ADD_ROLE_TO_USER, {
          input: {
            ...args,
          },
        });
        if (res?.data?.addRoleToUser) {
          const orgRoles = res?.data?.addRoleToUser?.orgRoles || [];

          // First try to match based on input args
          let match = orgRoles.find(
            (role: any) =>
              role.orgId?.name?.trim().toLowerCase() ===
                args?.orgName?.trim().toLowerCase() &&
              role.role?.name?.trim().toLowerCase() ===
                args?.role?.trim().toLowerCase()
          );

          // If no match found, fallback to the first valid org-role
          if (!match) {
            match = orgRoles.find((role: any) => role.orgId && role.role);
          }

          // If still nothing valid, handle gracefully
          if (!match) {
            throw new Error('No valid org-role found');
          }

          // Get IDs
          const orgId = match?.orgId?.orgId || null;
          const roleId = match?.role?.uuid || null;

          const res1 = await client
            .query(SWITCH_ROLE, { roleId: roleId, org: orgId })
            .toPromise();
          console.log('profileress->', res, token);
          if (res1?.data?.switchRole) {
            const storageSrv = StorageModule.getInstance();
            const content = { ...res1?.data };
            const _localData = storageSrv.get('userProfile', 'local');
            const _sessionData = storageSrv.get('userProfile', 'session');
            const userData = _sessionData ?? _localData;
            console.log('content->', content);
            storageSrv.set(
              'userProfile',
              {
                ...userData,
                accessToken: content?.switchRole?.accessToken,
                currentRole: args?.role,
                currentOrg: orgId,
              },
              'session'
            );
            return res?.data?.addRoleToUser;
          }

          throw res1?.data?.errors?.[0];
        }
        getErrorMessage(res?.error);
        throw res?.error;
      }
    } catch (err: any) {
      console.log(`Register user error`, err);
      // throw Error(err?.response?.data?.error?.display_message);
      throw err;
    }
  }
}

// const res1 = await axios.post(
//   `${apiConfig?.rest?.url}${signInUserConfig?.accessTokenEP}`,
//   {
//     jwtToken: usedToken,
//     role: args?.role,
//     org: orgId,
//   }
// );
// if (res1?.data) {
// const storageSrv = StorageModule.getInstance();
// const content = { ...res1?.data };
// const _localData = storageSrv.get('userProfile', 'local');
// const _sessionData = storageSrv.get('userProfile', 'session');
// const userData = _sessionData ?? _localData;
// console.log('content->', content);
// storageSrv.set(
//   'userProfile',
//   {
//     ...userData,
//     accessToken: content?.accessToken,
//     currentRole: args?.role,
//     userRoles: content?.userRoles,
//   },
//   'session'
// );
// } else {
//   getErrorMessage(res1?.statusText);
//   throw res?.error;
// }
